import { Box, Typography } from '@mui/material';
import { themeConfig } from 'src/theme';
import { Iconify } from '../iconify';

type CounterProps = {
  value: number;
  onChange: (value: number) => void;
};

export const Counter = (props: CounterProps) => {
  const addCounter = () => {
    props.onChange?.call(this, props.value + 1);
  };

  const minCounter = () => {
    if (props.value > 0) {
      props.onChange?.call(this, props.value - 1);
    }
  };

  return (
    <Box
      sx={{
        width: '88px',
        display: 'flex',
        padding: 'var(--spacing-05, 4px)',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        borderRadius: '8px',
        border: '1px solid var(--components-textfield-outline, rgba(145, 158, 171, 0.20))',
      }}
    >
      <Box
        sx={{ width: '26px', height: '26px', textAlign: 'center', cursor: 'pointer' }}
        onClick={minCounter}
      >
        <Iconify
          icon="ic:round-minus"
          sx={{
            color: themeConfig.palette.secondary,
          }}
        />
      </Box>
      <Box sx={{ width: '26px', height: '26px', textAlign: 'center' }}>
        <Typography variant="subtitle2" sx={{ lineHeight: '1.9' }}>
          {props.value}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '26px',
          height: '26px',
          textAlign: 'center',
          cursor: 'pointer',
          color: themeConfig.palette.primary.main,
        }}
        onClick={addCounter}
      >
        <Iconify icon="ic:round-plus" color="primary" />
      </Box>
    </Box>
  );
};
